import { c as _c } from "react/compiler-runtime";
import { NavLink } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
export interface SidebarSubItemProps {
  isActive: boolean;
  isDisabled?: boolean;
  label: string;
  tag?: string;
  to: string;
}

/** A page inside a step, indented under it. */
export const SidebarSubItem = t0 => {
  const $ = _c(14);
  const {
    isActive,
    isDisabled,
    label,
    tag,
    to
  } = t0;
  const t1 = isDisabled ?? undefined;
  const t2 = isDisabled ? -1 : undefined;
  const t3 = isActive && "bg-accent font-semibold text-foreground shadow-[inset_0_0_0_1px_var(--input)]";
  const t4 = isDisabled && "pointer-events-none opacity-50";
  let t5;
  if ($[0] !== t3 || $[1] !== t4) {
    t5 = cn("flex min-h-9 items-center gap-2.5 rounded-md py-1 pr-2.5 pl-[38px] text-sm text-muted-foreground transition-colors short:min-h-7 short:py-0.5", "hover:bg-accent hover:text-foreground", "focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none", t3, t4);
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== label) {
    t6 = <span>{label}</span>;
    $[3] = label;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== tag) {
    t7 = tag ? <Badge variant="monoOutline" className="ml-auto">{tag}</Badge> : null;
    $[5] = tag;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t5 || $[10] !== t6 || $[11] !== t7 || $[12] !== to) {
    t8 = <NavLink to={to} aria-disabled={t1} tabIndex={t2} className={t5}>{t6}{t7}</NavLink>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = to;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};